module.exports = __webpack_public_path__ + "static/media/selo_microsoft_partner_silver.a0f010a9.png";